
import Styled from "styled-components";
import { respondTo } from "@/respondTo";



export const MainScreenContainer = Styled.div <{bgColor?: string}>`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
background-color: ${({bgColor}) => bgColor ? bgColor : ""};
width:100%;
padding: 1.25rem 0;

${respondTo.desktop`
    padding: 1.25rem 0 2.5rem;
`}
 
`;

export const StepsTitle = Styled.div`
    display: flex;
    justify-content: center;
    padding: 3.125rem 1.25rem 0;
    width: 100%;

    ${respondTo.desktop`
        padding: 3.125rem 2.5rem 1.875rem;
    `}

    ${respondTo.desktop_xl`
        padding: 3.125rem 4.375rem 1.875rem;
    `}
    `

export const CardSteps = Styled.div`
padding: 1.25rem;

${respondTo.tablet_landscape_s`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
    padding: 1.25rem 2.5rem 1.25rem;
    gap: 1.25rem;
    `}



${respondTo.desktop_xl`
    padding: 1.25rem 4.375rem 1.25rem;
    gap: 160px;
`}
`
